<!--
 Компонент футера лендинга
 @versions: Baseline
 props: принимает флаг disclaimer - показывать / не показывать дисклеймер и disclaimerText - текст дисклеймера
-->

<template>
  <div class="footer-wrapper">
    <div class="footer">
      <div
        v-if="disclaimer"
        class="footer__disclaimer paragraph-12-300"
      >
        {{ $t(disclaimerText) }}
      </div>
      <div class="footer__location">
        <p v-html="$t('company_details')"></p>
      </div>
      <div class="footer__links">
        <a
          href="/privacy-policy.html"
          target="_blank"
          class="footer__link"
        >{{ $t('privacy_policy') }}</a>
        <a
          href="/terms.html"
          target="_blank"
          class="footer__link"
        >{{ $t('terms_and_conditions') }}</a>
        <a
          href="/refund.html"
          target="_blank"
          class="footer__link"
        >{{ $t('refund_policy') }}</a>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';

defineProps({
  disclaimer: {
    type: Boolean,
    default: true,
  },
  disclaimerText: {
    type: String as PropType<string>,
    default: '',
  },
});
</script>

<style lang="scss" scoped>
.footer-wrapper {
  display: flex;
  justify-content: center;
  background: $text-color;
  padding: 32px 32px 48px 32px;
  width: 100%;
}

.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 600px;

  &__disclaimer {
    color: $white;
    opacity: 0.5;
    font-weight: 400;
    text-align: center;
  }

  &__location {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: $white;
    opacity: 0.5;
    margin-bottom: 16px;
    margin-top: 32px;
  }

  &__links {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
  }

  &__link {
    color: $white;
    text-align: center;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-decoration-line: underline;
    opacity: 0.75;
  }
}
</style>
